import {
  Layout,
  SkeletonBodyText,
  SkeletonPage,
  BlockStack,
  Card,
  Box,
  Divider,
} from '@shopify/polaris';
import {Fragment} from 'react';
import {useGroupedTranslatableRoutes} from 'utilities/use-grouped-translatable-routes';

import {ResourceGroupHeader} from '../GroupedResourceList';

export const SkeletonHome = () => {
  const groupedTranslatableRoutes = useGroupedTranslatableRoutes();

  return (
    <SkeletonPage>
      <Layout>
        <Layout.Section>
          <Card padding="0">
            {groupedTranslatableRoutes.map(({label, items}, idx) => {
              return (
                <Fragment key={`resource-item-${label}`}>
                  <ResourceGroupHeader showTopBorder={idx !== 0}>
                    <Box padding="100" width="8rem">
                      <SkeletonBodyText lines={1} />
                    </Box>
                  </ResourceGroupHeader>
                  {items.map(({title}, idx) => (
                    <Fragment key={`skeleton-card-${title}`}>
                      <Box padding="600">
                        <SkeletonBodyText lines={1} />
                      </Box>
                      {idx !== items.length - 1 && <Divider />}
                    </Fragment>
                  ))}
                </Fragment>
              );
            })}
          </Card>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          <BlockStack gap="300">
            <Card>
              <SkeletonBodyText lines={6} />
            </Card>
            <Card>
              <SkeletonBodyText lines={2} />
            </Card>
            <Card>
              <SkeletonBodyText lines={6} />
            </Card>
          </BlockStack>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
};
